import { Injectable } from '@angular/core';
import { NetworkingService } from '../networking.service';
import { map, Observable } from 'rxjs';
import { Course } from '../../data/models/Course';
import { API } from '../../data/api';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

  constructor(private networkingService: NetworkingService) { }

  getCourseList(id: string): Observable<Course[]> {
    return this.networkingService.getRequest(API.courseList)
      .pipe(
        map(response => response as Course[])
      );
  }

  getCourseDetails(id: string): Observable<Course> {
    const endpoint = API.courseDetails(id);
    return this.networkingService.getRequest(endpoint)
      .pipe(
        map(response => response as Course)
      );
  }

  alterCourse(id: string, welcomeText?: string): Observable<Course> {
    const endpoint = API.courseAlter(id);
    const payload = {
      welcome_text: welcomeText
    };

    return this.networkingService.putRequest(endpoint, payload)
      .pipe(
        map(response => response as Course) 
      );
  }
}
